import Vue from "vue";
import { mapGetters } from "vuex";
import { CurrencyText, LoadingSpinner, PartDetailsLink } from "@/components";
import { stringHelper, formatDateTime } from "@/components/mixins";
import { BackorderService, ErrorLogService } from "@/services/";
import { IBackOrdersAlternativesListRequestDto } from "@/services/BackorderService"

export default Vue.extend({
    name: "BackorderOptions",

    components: { CurrencyText, LoadingSpinner, PartDetailsLink },
    mixins: [formatDateTime, stringHelper],

    props: {
        backorder: {
            type: Object,
            required: true,
        },
        showDetails: {
            type: Boolean,
            required: false
        }
    },

    computed: {
        ...mapGetters([
            "user",
            "activeAccountId",
            "getContentItem",
            "tenantDetails",
            "hasPermission",
            "canSeeAnyPrice",
            "canSeeContractPrice",
            "canSeeDealerNet",
            "audienceIds"
        ]),
        mostRecentFollowup(){
            if(this.backorder.BackorderRequestFollowupDtos  && 
                this.backorder.BackorderRequestFollowupDtos.length > 0)
            {
                return this.backorder.BackorderRequestFollowupDtos[0];
            }
            return false;
        }
    },


    mounted() {
        this.newCrmTicketNumber = this.backorder.CrmTicketNumber;  
    },

    data: () => ({
        showAddEditCrmTicketNumberField: false,
        submittingCrmTicketNumber: false,
        newCrmTicketNumber: "",
        loadingPartAlternatives: true, 
        partAlternatives: [],
        haveLoadedPartAlternatives: false,
        backorderPidId: "0d6b9e8c-fa3d-e411-8b3c-005056870039"
    }),

    methods: {
        showAlternativeParts(){
            this.$emit("showAlternativeParts", this.backorder.OemPartCode, this.AlternativeParts);
        },
        toggleDetails(){
            this.$emit("toggleDetails", this.backorder);
        },
        requestFollowup(){
            this.$emit('requestFollowup', this.backorder);
        }   
    },
});
